import * as React from "react";
const SvgUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 12, viewBox: "0 0 16 12", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m8 .5 8 11H0z", fill: "#FFF", fillRule: "evenodd" }));
export default SvgUp;
